import axios from 'axios'
export default axios.create({
  baseURL: 'https://base.zenkit.com/api/v1/',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    'Zenkit-API-Key': process.env.VUE_APP_ZENKIT
  }
})



